import { useRef } from 'react';
import usePageTitle from 'hooks/usePageTitle';
import Layout from 'layouts';
import Markdown from 'components/Markdown';
import { useScrollTo } from 'hooks/useScrollTo';
import { Typography } from '@mui/material';
import { referAndEarnCopy, termsCopy } from './termsCopy';
import { StyledContainer, Bubble, StyledBackground, Subtitle } from './Terms.styles';

const Terms = () => {
  usePageTitle('Terms & Conditions');
  const referAndEarnRef = useRef<HTMLHeadingElement>(null);

  useScrollTo(referAndEarnRef, { tolerance: 80 });

  return (
    <Layout ariaLabel="Terms and Conditions page">
      <StyledContainer>
        <Typography variant="h1">Full T&amp;Cs</Typography>
        <Typography variant="h1">(the boring bits)</Typography>
        <StyledBackground>
          <Bubble />
        </StyledBackground>
        <Markdown>{termsCopy}</Markdown>
        <Subtitle ref={referAndEarnRef} variant="h2" id="referfriend">
          Refer and Earn
        </Subtitle>
        <Markdown>{referAndEarnCopy}</Markdown>
      </StyledContainer>
    </Layout>
  );
};

export default Terms;
